import React from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Avatar,
  Menu,
  MenuItem
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import styles from './Header.module.scss';
import profileImage from '../../assets/images/profile.jpg';
import { useNavigate } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { APP_MAINPAGE_URL } from '../../config/config';
import { useIdleLogout } from '../../utils/useIdleLogout';

interface HeaderProps {
  handleDrawerToggle: () => void;
  open: boolean;
  darkMode: boolean;
  handleThemeToggle: () => void;
}

const Header: React.FC<HeaderProps> = ({ handleDrawerToggle, open }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const userData: any = JSON.parse(localStorage.getItem("userData") || "{}")
  const menuOpen = Boolean(anchorEl);
  const navigate = useNavigate();
  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    // Clear session data and redirect
    localStorage.clear();
    handleMenuClose();
    // navigate('/login'); // Use this if you have a login route
    window.location.href = APP_MAINPAGE_URL;
  };
  useIdleLogout(handleLogout, 600000);
  return (
    <>
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        width: open ? 'calc(100% - 19.375rem)' : 'calc(100% - 4rem)', // Adjust based on sidebar width
        ml: open ? '19.375rem' : '4rem',
        transition: 'width 0.3s ease, margin-left 0.3s ease',
        boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.05) !important;', // Remove default app bar shadow
        borderBottom: '1px solid var(--mui-palette-divider)', // Subtle border
        backgroundColor: '#fff', // Use Material-UI theme paper background
      }}
    >
      <Toolbar className={styles.toolbar}>
        <IconButton
          color="inherit"
          aria-label={open ? "close drawer" : "open drawer"}
          onClick={handleDrawerToggle}
          edge="start"
          sx={{ mr: 2, color: '#0070D8' }}
        >
          {open ? (
            
            <ChevronLeftIcon />
          ) : (
            <ChevronRightIcon />
          )}
        </IconButton>
 
        <Box sx={{ flexGrow: 1 }} /> {/* Spacer */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton onClick={handleMenuOpen} sx={{ p: 0 }}>
              <Avatar alt="Srbf Team" src={profileImage} sx={{ width: 32, height: 32, ml: 0 }} />
            </IconButton>
            <Box sx={{ display: 'flex', flexDirection: 'column', ml: 1 }}>
              <Typography variant="body2" className={styles.profileName} sx={{ color: '#0070D8' }}>
                {userData.full_name}
              </Typography>
              <Typography variant="caption" className={styles.profileRole} sx={{ color: 'var(--mui-palette-text-secondary)' }}>
                {userData.role}
              </Typography>
            </Box>
          </Box>
      </Toolbar>
    </AppBar>
    {/* Logout Menu */}
      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={handleLogout}>
          <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};

export default Header;